import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              {site.slogan}。{site.intro}
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line" />
              <a href={`mailto:${site.email}`} className="transition-colors hover:text-accent-400">
                {site.email}
              </a>
            </p>
          </div>

          {site.footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {group.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => {
                  const isHash = link.to.includes("#");
                  return (
                    <li key={link.label}>
                      {isHash ? (
                        <Link
                          to={link.to.split("#")[0] || "/"}
                          className="text-sm text-background-300 transition-colors hover:text-accent-400"
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <Link
                          to={link.to}
                          className="text-sm text-background-300 transition-colors hover:text-accent-400"
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {site.name} · 内容仅为话题扩散观察，涉及人物均已匿名化处理。</p>
          <p className="flex items-center gap-2">
            <i className="ri-refresh-line" />
            {site.updateNote}
          </p>
        </div>
      </div>
    </footer>
  );
}